import { useState, useEffect } from 'react';
import { fetchPortalBuilderTemplates } from '../services/portalBuilderService';

export const usePortalBuilderTemplates = (
  token,
  deleteStatus,
  templateStatus
) => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    (async () => {
      const data = await fetchPortalBuilderTemplates(
        token,
        deleteStatus,
        templateStatus
      );
      setTemplates(data);
    })();
  }, [token, deleteStatus, templateStatus]);

  return { templates, setTemplates };
};
